import api from "./api";

// Salva a análise do questionário
// Endpoint: PUT /api/questionarioResposta/salvarAnalise/{id}
export const salvarAnalise = async (idQuestionarioResposta, payload) => {
  try {
    const response = await api.put(
      `/api/questionarioResposta/salvarAnalise/${idQuestionarioResposta}`,
      payload,
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

// Busca o histórico da análise e adequação do questionário
// Endpoint: GET /api/questionarioResposta/getHistoricoAnaliseAdequacaoQuestionario/{id}
export const getHistoricoAnalise = async (idQuestionario) => {
  try {
    const response = await api.get(
      `/api/questionarioResposta/getHistoricoAnaliseAdequacaoQuestionario/${idQuestionario}`,
    );

    if (
      response?.data?.historicoAnaliseAdequacaoCampoQuestionarioJson &&
      Array.isArray(
        response.data.historicoAnaliseAdequacaoCampoQuestionarioJson,
      )
    ) {
      return response.data;
    } else {
      return {
        historicoAnaliseAdequacaoCampoQuestionarioJson: [],
      };
    }
  } catch (e) {
    console.error("Erro ao buscar histórico da análise serio:", e);
    return {
      historicoAnaliseAdequacaoCampoQuestionarioJson: [],
    };
  }
};

// Conclui a análise do questionário
// Endpoint: PUT /api/questionarioResposta/concluirAnalise/{id}
export const concluirAnalise = async (idQuestionarioResposta, payload) => {
  try {
    const response = await api.put(
      `/api/questionarioResposta/concluirAnalise/${idQuestionarioResposta}`,
      payload,
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

// Solicita adequação do questionário
// Endpoint: PUT /api/questionarioResposta/solicitarAdequacao/{id}
export const solicitarAdequacao = async (idQuestionarioResposta, payload) => {
  try {
    const response = await api.put(
      `/api/questionarioResposta/solicitarAdequacao/${idQuestionarioResposta}`,
      payload,
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
